import Button from 'components/ui/Button'
import { useCartApplyCoupon } from 'components/pages/CartPage/Coupon/types/cartApplyCoupon'
import { useCartRemoveCoupon } from 'components/pages/CartPage/Coupon/types/cartRemoveCoupon'
import getMutationError from 'utils/getMutationError'
import { useState } from 'react'
import TextField from 'components/ui/TextField'

type Props = {
  uuid: string
  currentCoupon?: string
  refetch: () => void
  setError: (error: string | null) => void
}

const Coupon = ({ uuid, currentCoupon, refetch, setError }: Props) => {
  const [coupon, setCoupon] = useState<string>(currentCoupon || '')
  const [showCoupon, setShowCoupon] = useState<boolean>(false)

  const [cartApplyCoupon] = useCartApplyCoupon({
    onError: (e) => {
      setError(e.message)
    },
    onCompleted: () => {
      setError(null)
    }
  })

  const [cartRemoveCoupon] = useCartRemoveCoupon({
    onError: (e) => {
      setError(e.message)
    },
    onCompleted: () => {
      setError(null)
    }
  })

  const onApplyCoupon = async () => {
    const response = await cartApplyCoupon({
      variables: {
        cartUuid: uuid,
        couponCode: coupon
      }
    })
    if (getMutationError(response!)) return

    await refetch()
  }

  const onRemoveCoupon = async () => {
    setCoupon('')
    setShowCoupon(false)
    const response = await cartRemoveCoupon({
      variables: {
        cartUuid: uuid
      }
    })
    if (getMutationError(response!)) return

    await refetch()
  }

  return (
    <div>
      {showCoupon || currentCoupon ? (
        <>
          <div className="block text-sm font-medium text-gray-700">
            Use a coupon
          </div>
          <div className="flex">
            <TextField
              name="coupon"
              onChange={(e) => {
                setCoupon(e.target.value)
                setError(null)
              }}
              value={coupon}
            />
            <div className="mt-1 ml-2">
              {currentCoupon ? (
                <Button
                  color="secondary"
                  onClick={onRemoveCoupon}
                  size="medium"
                  variant="outline"
                >
                  <span className="whitespace-nowrap">Remove Coupon</span>
                </Button>
              ) : (
                <Button
                  color="primary"
                  onClick={onApplyCoupon}
                  size="medium"
                  variant="outline"
                >
                  <span className="whitespace-nowrap">Apply</span>
                </Button>
              )}
            </div>
          </div>
        </>
      ) : (
        <Button
          color="default"
          onClick={() => setShowCoupon(true)}
          size="small"
          variant="anchor"
        >
          Use a coupon
        </Button>
      )}
    </div>
  )
}

export default Coupon
